




























































































































import { Component, Vue } from "vue-property-decorator";
import {
  PaginationItem,
  AuthorRecipeListParamsItem,
  LinksItem
} from "@/response";
import { ActionTypes } from "@/store/aciton-types";

export interface InputItem {
  q: string;
}

@Component({
  props: {
    enableResult: { type: Boolean, default: true },
    enablePagination: { type: Boolean, default: true },
    enableDisplay: { type: Boolean, default: true },
    enableVisibility: { type: Boolean, default: true },
    username: String
  }
})
export default class AuthorFilterComponent extends Vue {
  // get username(): string {
  //   return this.$props.username;
  // }

  get isAuthor(): boolean {
    try {
      return (
        this.$props.username ===
        (<any>this.$store.state).userStore.profile.username
      );
    } catch (error) {
      return false;
    }
  }

  get listParams(): AuthorRecipeListParamsItem {
    return this.$store.state.userStore.listParams;
  }

  get pagination(): PaginationItem {
    try {
      return this.$store.state.recipeStore.pagination;
    } catch (e) {
      return <PaginationItem>{
        links: <LinksItem>{}
      };
    }
  }

  onChangePage(page: number) {
    this.resetRecipeList(
      this.$props.username,
      page,
      this.listParams.perPage,
      this.listParams.visibility
    );
  }

  onChangePerPage(perPage: number) {
    this.resetRecipeList(
      this.$props.username,
      1,
      perPage,
      this.listParams.visibility
    );
  }

  onChangeVisibility(visibility: string) {
    this.resetRecipeList(
      this.$props.username,
      1,
      this.listParams.perPage,
      visibility
    );
  }

  resetRecipeList(
    username: string,
    page?: number,
    perPage?: number,
    visibility?: string
  ) {
    this.$store.dispatch(ActionTypes.GET_USER_RECIPE_LIST, {
      username: username,
      page: page,
      perPage: perPage,
      visibility: visibility
    });
  }

  beforeMount() {}
}
